import { GetQuestsProgressResponse } from "../../types/quests";

export const getQuestsProgressModel = (
  response: GetQuestsProgressResponse
): GetQuestsProgressResponse => response;
